import React from "react";
import { cn } from "../utils";
import { Label, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";

import { CustomTooltip } from "./CustomTooltip";

import {
  LabelContentStyle,
  LabelContentTopStyle,
  LabelTitleStyle,
} from "../Chart.styles";

export const PiesChart = ({
  data,
  dataKey,
  dataset,
  size,
  label,
  showLegend,
  className,
}) => {
  const textColor = "#737373";
  return (
    <ResponsiveContainer width="100%" height={size?.height || 300}>
      <PieChart
        margin={{
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
        }}
      >
      <Tooltip content={<CustomTooltip />} />
      {showLegend === true && <Legend />}
      
        <Pie
          data={data}
          dataKey={dataKey.xAxis}
          nameKey={""}
          innerRadius={size.innerRadius}
          strokeWidth={5}
        >

          <Label
            content={({ viewBox }) => {
              if (viewBox && "cx" in viewBox && "cy" in viewBox) {
                return (
                  <text
                    x={viewBox.cx}
                    y={viewBox.cy}
                    textAnchor="middle"
                    dominantBaseline="middle"
                  >
                    <tspan
                      x={viewBox.cx}
                      y={(viewBox.cy || 0) - 24}
                      fill={textColor}
                      className={cn(LabelContentTopStyle(), className)}
                    >
                      {label?.top}
                    </tspan>
                    <tspan
                      x={viewBox.cx}
                      y={viewBox.cy}
                      className={cn(LabelTitleStyle(), className)}
                    >
                      {label?.center}
                    </tspan>
                    <tspan
                      x={viewBox.cx}
                      y={(viewBox.cy || 0) + 24}
                      fill={textColor}
                      className={cn(LabelContentStyle(), className)}
                    >
                      {label?.bottom}
                    </tspan>
                  </text>
                );
              }
            }}
          />
        </Pie>
      
      </PieChart>
    </ResponsiveContainer>
  );
};
